import React from 'react';
import Flex from '../../Flex';
import { Button, Progress, Table, Row, Col, List } from 'antd';
import TitleTop from '../../Assembly/titleTop';
import style from './index.css';
// import {getLoginUser,createUuid} from '../../../utils/NHCore';
import createHistory from 'history/createHashHistory';
import BarCode from 'react-barcode';
import KzxxFormc from '../../KzxxFormc';

const history = createHistory();
/**
 * 成都纺织学校报到单页面
 * Author: lisenlin@ly-sky.com
 * Created on: 2020-09-30 10:30:00
 * Version: 1.0
 * Modify log: 要使用该报到单需在系统配置中配置学校代码为cdfzxx
 */
export default class CdzyxxPrint extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            xsxx:this.props.initFormDate,//学生信息
            schoolName:this.props.schoolName,//学校名称
            year:this.props.year,//当前年度
            account:this.props.account,//默认账号
            kzxxInitData: this.props.kzxxInitData,
            nr:this.props.nr,
            stucjzjxx: this.props.stucjzjxx, //学生采集字段
            // 备注内容
            bzlist: [
                {id: 1, bz: '党团组织关系请交到本班辅导员处。'},
                {id: 2, bz: '新生务必在报到三日内到学校卫生所体检。'},
                {id: 3, bz: '新生纸质档案交各班辅导员，由系部汇总后交学生处。'},
                {id: 4, bz: '辅导员将4张照片，分别送所在系、学生处、保卫处、学生处宿管科。'},
                {id: 5, bz: '辅导员收齐《报到单》后，汇总交学院备案（保留一年）。'},
            ],
            //教学学院办理内容
            jxxyblnr: [
                '1.交身份证复印件、交照片(4张)、交此《新生报到单》；',
                '2.费用已通过银行代收成功的新生同学请到本班辅导员处领取相关票据。'
            ],
        };
    }

    getList = () => {
        let bzlist = this.state.bzlist;
        

    }

    render() {
        const { xsxx, schoolName, year, nr, account,kzxxInitData, bzlist, jxxyblnr, stucjzjxx} = this.state;
        let xqmc = xsxx.xqmc;
        let ldmc = xsxx.ldmc;
        let fjmc = xsxx.fjmc;
        let cwh = xsxx.cwh;
        // 采集表中的这三个字段，就是缴费系统的三个字段 实收、应收、欠费
        let ZDYSSJE = stucjzjxx.ZDYSSJE;
        let ZDYYSJE = stucjzjxx.ZDYYSJE;
        let ZDYQFJE = stucjzjxx.ZDYQFJE; 
        // 缴费状态 欠费为0时则为'已缴费' 否则显示空白
        let JFstate = stucjzjxx.ZDYQFJE == 0 ? '已缴费' : ''

        // 一卡通窗口信息
        let ZDYYKTBLCK = stucjzjxx.ZDYYKTBLCK;
        // let nrList = [];//内容list
        // if(nr && nr.length>0) {
        //     nr.map((elem,index)=>{
        //         nrList.push(
        //             <div>
        //                 <div className={style.ejxybd_label1}>
        //                     <span>
        //                     {index+1}
        //                     </span>
        //                 </div>
        //                 <div className={style.ejxybd_label2}>
        //                     <span>
        //                     {elem.HJMC}
        //                     </span>
        //                 </div>
        //             </div>
        //             )
        //         }
        //     )
        // }

        
        // 成都纺织学校办理手续表格列及列内渲染（如合并 列内对齐），因为表格内部分数据固定的，所以在这里直接写了数据及设置行列合并效果
        const Columns = [
            {
                title: '序号',
                dataIndex: 'sort',
                align:'center',
                width:50,
                render: (text, row, index) => {
                    const obj = {
                        children: text,
                        props: {},
                    };
                    if (index === 2) {
                        obj.props.rowSpan = 3;
                    }
                    if (index === 3) {
                        obj.props.rowSpan = 0;
                    }
                    if (index === 4) {
                        obj.props.rowSpan = 0;
                    }
                    if (index === 6) {
                        obj.props.colSpan = 4;
                    }
                    return obj;
                },
            },
            {
                title: '部门',
                dataIndex: 'bmmc',
                align:'center',
                width:120,
                render: (text, row, index) => {
                    const obj = {
                        children: text,
                        props: {},
                    };
                    if (index === 2) {
                        obj.props.rowSpan = 3;
                    }
                    if (index === 3) {
                        obj.props.rowSpan = 0;
                    }
                    if (index === 4) {
                        obj.props.rowSpan = 0;
                    }
                    if (index === 6) {
                        obj.props.colSpan = 0;
                    }
                    return obj;
                },
            },
            {
                title: '办理手续内容',
                dataIndex: 'blsxnr',
                align:'center',
                width:250,
                render: (text, row, index) => {
                    const obj = {
                        children: text,
                        props: {},
                    };
                    if(index === 0) {
                        obj.children = <div style={{textAlign:'left'}}>
                                        {text}
                                       </div>
                    }
                    if(index === 1) {
                        obj.children = <div style={{textAlign:'left'}}>
                                            <div>应缴费：￥{ZDYYSJE}</div>
                                            <div>已缴费：￥{ZDYSSJE}</div>
                                            <div>还需缴费：￥{ZDYQFJE}</div>
                                       </div>
                    }
                    if(index === 5) {
                        obj.children = <div style={{textAlign:'left' }}>
                                            {jxxyblnr&&jxxyblnr.map(item=>{
                                                return <div>{item}</div>
                                            })
                                            }
                                       </div>
                    }
                    if (index === 6) {
                        obj.props.colSpan = 0;
                    }
                    return obj;
                },
            },
            {
                title: '签字/盖章',
                dataIndex: 'qzgz',
                align:'center',
                width:180,
                render: (text, row, index) => {
                    const obj = {
                        children: text,
                        props: {},
                    };
                    if(index === 0) {
                        obj.children = <img src={require('./image/zsjyc.jpg')} width={108} height={25} />;
                    }
                    if(index === 1) {
                        obj.children = JFstate
                    }
                    if(index === 2) {
                    obj.children = <div style={{textAlign:'left' }}>
                                        {fjmc? <div>宿舍号：{fjmc}</div> : null }
                                        {ldmc? <div>学生公寓：{ldmc}</div> : null}
                                        {cwh? <div>床位号：{cwh}</div> : null}                                    
                                   </div>
                    }
                    if (index === 6) {
                        obj.props.colSpan = 0;
                        
                    }
                    return obj;
                },
            },
            {
                title: '备注',
                dataIndex: 'bz',
                align:'center',
                // width: ,
                render: (text, row, index) => {
                    const obj = {
                        children: text,
                        props: {},
                    };
                    if (index === 0) {
                        obj.children = 
                        <List
                        size="small"
                        style={{textAlign:'left'}}
                        bordered={false}
                        split={false}
                        dataSource={bzlist}
                        renderItem={item => <List.Item key={item.id}>{item.id}、{item.bz}</List.Item>}
                        />
                        obj.props.rowSpan = 7;
                    }
                    if (index !== 0) {
                        obj.props.rowSpan = 0;
                    }
                    return obj;
                },
            }
        ];
        // 成都紡織學校报到单办理手续表格部分内容
        const dataSource = [
        {
            key: 1,
            sort: '1',
            bmmc: '招生结业处',
            blsxnr: '收《录取通知书》、领《报到单》、体检表',
            qzgz: '招生就业处',
            bz:''
        },
        {
            key: 2,
            sort: '2',
            bmmc: '计划财务处',
            blsxnr: '应缴费',
            qzgz: '已缴费',
            bz:''
        },
        {
            key: 3,
            sort: '3',
            bmmc: '学工综合服务',
            blsxnr: '宿管科办理宿舍',
            qzgz: '寝室号',
            bz:''
        },
        {
            key: 4,
            sort: '3',
            bmmc: '',
            blsxnr: '学生处办理保险',
            qzgz: '',
            bz:''
        },
        {
            key: 5,
            sort: '3',
            bmmc: '',
            blsxnr: '信息中心办理校园一卡通（饭卡）',
            qzgz: ZDYYKTBLCK,
            bz:''
        },
        {
            key: 6,
            sort: '4',
            bmmc: '教学学院',
            blsxnr: '1.交身份证复印件、交照片（4张），交此《学生报到单》；2.费用已通过银行代收成功的新生同学请到本班辅导员处领取相关票据。',
            qzgz: '',
            bz:''
        },
        {
            key: 7,
            sort:'领取军训服装',
            bmmc: '',
            blsxnr: '',
            qzgz: '',
            bz:''
        }
        ];
          
        return (
            <div className="box" style={{width:'210mm',margin:'0 auto'}}>
                <div className={style.repTop}>
                    <img src={require('./image/cdfzxxlogo.png')} width="480"/>
                    <div className={style.repTopTitle}>
                        <div>2020年</div>
                        <div>新生入学报到单</div>
                    </div>
                </div>
                <div className={style.repMain}>
                    <div style={{textAlign: 'center'}}>
                        <div  className={style.title}>
                            新生入学报到信息
                        </div>
                    </div>

                    <Flex className={style.p_sw_big} style={{display:'flex'}}>
                        
                        <Flex.Item className={style.ml_10}>
                            {[
                                {
                                    label: '学号',
                                    name: xsxx.xh
                                },
                                {
                                    label: '姓名',
                                    name: xsxx.xm
                                },
                                {
                                    label: '考生编号',
                                    name: xsxx.ksh
                                },
                                
                                {
                                    label: '科类',
                                    name: xsxx.xslb
                                },
                                {
                                    label: '性别',
                                    name: xsxx.xb
                                },
                                {
                                    label: '身份证号',
                                    name: xsxx.sfzjh
                                },
                                {
                                    label: '录取专业',
                                    name: xsxx.zymc
                                },
                                {
                                    label: '联系电话',
                                    name: xsxx.sjhm
                                }
                                
                            ].map((elem, index) => {
                                return (
                                    <div className={style.jbxx_item} key={index}>
                                        <span className={style.item_label}>
                                        {elem.label}：</span>
                                        <div className={style.item_name_t_clamp_1}>
                                        {elem.name}
                                        </div>
                                    </div>
                                );
                            })}
                        </Flex.Item>
                        <img className={style.jbxx_icon_bg} src={'api/sm-student/openapi/getStudentPhoto?xsid=' + xsxx.xsid+'&type=10'}/>
                    </Flex>
                    <div className='tbl_list'>
                        <Table style={{ fontSize: '14px' , padding:'5px 10px'}} className={style.LcTable} dataSource={dataSource} columns={Columns} pagination={false} bordered={true}/>
                    </div>
                    
                    
                    <div className={style.p_sw_big} style={{display:'flex', justifyContent:'center'}}>
                        
                        <div className={style.bttom_barcode}>
                        <BarCode
                        className={style.bz_img}
                        value={xsxx.ksh}
                        width={2}
                        height={60}
                        fontSize={14}
                        >
                        </BarCode>
                        </div>
                        <div className={style.bttom_barcode}>
                        <BarCode
                        className={style.bz_img}
                        value={account}
                        width={2}
                        height={60}
                        fontSize={14}
                        >
                        </BarCode>
                        </div>
                    </div>
                    <div className={style.bottom_copyright}>
                    Copyright © 2008-2020 成都纺织高等专科学校All Rights Reserved. 信息化管理中心设计 -Email:wth2002@163.com-
                    </div>
                    </div>
                <style jsx="true" global="true">
                    {`
                        .ant-table table{
                            font-size: 14px;
                        }
                    `}
                </style>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/yxxc/print/Bdd/cdzyxx/CdzyxxPrint.js